export const comunicationQuestions = {
	engagement: {
		id: "engagement",
		steps: {
			"1": { // 3.1
				id: "1",
				type: "radio",
				label: "Existem projetos desenvolvidos com as comunidades locais em questões relacionadas à água?",
				options: [
					{
						label: "a) Sim, existem projetos desenvolvidos com as comunidades locais em questões relacionadas com à água.", 
						id: "A"
					},
					{
						label: "b) Sim, existem projetos desenvolvidos com as comunidades locais sendo planejados, entretanto ainda não foram implementados.", 
						id: "B"
					},
					{
						label: "c) Não, porém a empresa possui planos para desenvolver projetos com as comunidades locais no futuro", 
						id: "C"
					},
					{
						label: "d) Não existem projetos desenvolvidos com as comunidades locais, em questões relacionadas à água.", 
						id: "D"
					},
				]
			},
			"1-1": { // 3.1.1
				id: "1-1",
				type: "textArea",
				label: "Descreva ações realizadas com a comunidade local.",
				options: [
					{id: "description", label: "Resposta."}
				]
			},
			"2": { // 3.2
				id: "2",
				type: "radio",
				label: "A empresa trabalha a conscientização dos colaboradores para o tema da 'água', através de treinamentos, eventos, informativos, workshop, etc?",
				options: [
					{
						label: "a) Sim, a empresa trabalha a conscientização dos colaboradores para o tema da 'água', realizando todas ações necessárias.", 
						id: "A"
					},
					{
						label: "b) Sim, existe na empresa planejamento para ação, porém por enquanto só informativos visuais foram adotados.", 
						id: "B"
					},
					{
						label: "c) Não, porém existem planos para desenvolver.", 
						id: "C"
					},
					{
						label: "d) Não, a empresa não trabalha a conscientização dos colaboradores para o tema da 'água'.", 
						id: "D"
					},
				]
			},
			"2-1": { // 3.2.1
				id: "2-1",
				type: "textArea",
				label: "Descreva quais ações foram tomadas para conscientização dos colaboradores.",
				options: [
					{id: "description", label: "Resposta."}
				]
			},
			"3": { // 3.3
				id: "3",
				type: "radio",
				label: "A empresa incorpora a gestão hídrica dos seus fornecedores como critério de contratação?",
				options: [
					{
						label: "a) Sim, a empresa incorpora a gestão hídrica do fornecedor como fator decisivo na contratação e realiza ações de engajamento junto aos seus fornecedores para incentivar boas práticas de gestão da água.", 
						id: "A"
					},
					{
						label: "b) Sim, a empresa incorpora a gestão hídrica do fornecedor e realiza ações de engajamento para incentivar boas práticas de gestão da água, no entanto não é fator decisivo para a contratação.", 
						id: "B"
					},
					{
						label: "c) Não, a empresa não incorpora a gestão hídrica do fornecedor na contratação, porém possui planos de implementar esta prática.", 
						id: "C"
					},
					{
						label: "d) Não, a empresa não incorpora a gestão hídrica do fornecedor como critério de contratação.", 
						id: "D"
					},
				]
			},
			"4": { // 3.4
				id: "4",
				type: "radio",
				label: "A empresa informa / educa seus clientes para ajudá-los a minimizar os impactos do produto associados ao uso da água? Ex. Descarte adequado, reciclagem, consumo consciente, etc...",
				options: [
					{
						label: "a) Sim, empresa informa / educa os clientes para ajudá-los a minimizar os impactos de produto associados ao uso da água e ainda desenvolve os produtos com os menores impactos sobre os recursos hídricos.", 
						id: "A"
					},
					{
						label: "b) Sim, empresa informa / educa os clientes para ajudá-los a minimizar os impactos de produto associados ao uso da água, mas não desenvolve os produtos com os menores impactos sobre os recursos hídricos.", 
						id: "B"
					},
					{
						label: "c) Não, a empresa não informa / educa os clientes para ajudá-los a minimizar os impactos de produto associados ao uso da água, porém têm planos para serem implementados.", 
						id: "C"
					},
					{
						label: "d) Não, a empresa não informa / educa os clientes para ajudá-los a minimizar os impactos de produto.", 
						id: "D"
					},
				]
			}
		}
	},
	comunications: {
		id: "comunications",
		steps: {
			"1": { // 3.5
				id: "1",
				type: "radio",
				label: "Existe na empresa algum canal de comunicação interno e/ou externo que disponibiliza informações relacionadas com a gestão da água, sustentabilidade?",
				options: [
					{
						label: "a) Sim, existe na empresa canais de comunicação interno e externo.", 
						id: "A"
					},
					{
						label: "b) Sim, existe na empresa canal de comunicação interno.", 
						id: "B"
					},
					{
						label: "c) Não, na empresa não existem canais de comunicação, entretanto existem planos para implementar.", 
						id: "C"
					},
					{
						label: "d) Não, na empresa não existem canais de comunicação.", 
						id: "D"
					},
				]
			},
		}
	}
};


// WEBPACK FOOTER //
// src/models/lib/questions/comunicationQuestions.js